import { FilterOption } from '../interfaces/filter-options.interface';
export type FilterSection =
  | 'price'
  | 'productName'
  | 'brandName'
  | 'category'
  | 'productLocation'
  | 'status'
  | 'availableAmount'
  | 'reservedAmount'
  | 'onHandAmount'
  | 'sortBy';

export interface RangeFilterConfig {
  minControl: string;
  maxControl: string;
  defaultMin: number;
  defaultMax: number;
}

export const RANGE_FILTER_CONFIGS: Record<
  Extract<FilterSection, 'price' | 'availableAmount' | 'reservedAmount' | 'onHandAmount'>,
  RangeFilterConfig
> = {
  price: {
    minControl: 'priceMin',
    maxControl: 'priceMax',
    defaultMin: 0,
    defaultMax: 1000,
  },
  availableAmount: {
    minControl: 'availableAmountMin',
    maxControl: 'availableAmountMax',
    defaultMin: 0,
    defaultMax: 1000,
  },
  reservedAmount: {
    minControl: 'reservedAmountMin',
    maxControl: 'reservedAmountMax',
    defaultMin: 0,
    defaultMax: 1000,
  },
  onHandAmount: {
    minControl: 'onHandAmountMin',
    maxControl: 'onHandAmountMax',
    defaultMin: 0,
    defaultMax: 1000,
  },
};

export interface InventoryTextFilterConfig {
  key: FilterSection;
  type: 'text';
  title: string;
  placeholder: string;
}

export interface InventorySelectFilterConfig<TItem> {
  key: FilterSection;
  type: 'select';
  title: string;
  options: () => TItem[];
  placeholder: string;
  emptyPlaceholder: string;
}

export interface InventoryRangeFilterConfig {
  key: FilterSection;
  type: 'range';
  title: string;
  min: number;
  max: number;
  step: number;
}

export type FilterConfig<TSelectItem = FilterOption | string> =
  | InventoryTextFilterConfig
  | InventoryRangeFilterConfig
  | InventorySelectFilterConfig<TSelectItem>;

export interface ActiveInventoryCriterion {
  key: FilterSection;
  label: string;
  value: string;
}
